import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharedUpdateService } from '../../shared/dialogs/update.service';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { BaseDialog } from '../../shared/dialogs/base-dialog';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FertilizationDialogFields } from '../main';
import { IIrrigationMethod } from '../../../models/irrigation-method/interfaces';
import { NContributionUpdateService } from './n-contribution-update-service';
import { IRanchWellViewModel } from '../../ranch-settings/interfaces';

export interface NContributionDialogData {
	form: FormGroup,
	nContributionForm: FormGroup,
	irrigationMethods: IIrrigationMethod[],
	units: number,
	needsWells?: boolean,
	wellsForm?: FormArray,
	NContribution: {
		UIVisible: boolean,
		calculatedPPM: number,
		recommendationHours: number,
		nextFertilizationDate: Date,
		canSaveWellsAsPlantingDefault?: boolean,
	}
}

@Component({
	moduleId: module.id,
	selector: 'n-contribution-dialog',
	templateUrl: 'n-contribution-dialog.html',
	styleUrls: []
})

export class NContributionDialog extends BaseDialog implements OnInit, OnDestroy {

	protected _subscriptions$: Subject<boolean>;
	public form: FormGroup;
	public nContributionForm: FormGroup;
	public irrigationMethods: IIrrigationMethod[];
	public units: number;
	public showWells: boolean;
	public wellsForm: FormArray;

	public NContribution: {
		UIVisible: boolean,
		calculatedPPM: number,
		recommendationHours: number,
		nextFertilizationDate: Date,
		canSaveWellsAsPlantingDefault?: boolean,
	};

	public get f(): { [key in FertilizationDialogFields]: AbstractControl } {
		if (!this.form) {
			return null
		};

		return this.form.controls as { [key in FertilizationDialogFields]: AbstractControl };
	}

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: NContributionDialogData,
		private dialog: MatDialog,
		private dialogRef: MatDialogRef<NContributionDialog>,
		private sharedUpdateService: SharedUpdateService,
		private nContributionUpdateService: NContributionUpdateService
	) {
		super(dialog, dialogRef, sharedUpdateService);
		this.form = data.form;
		this.nContributionForm = data.nContributionForm;
		this.irrigationMethods = data.irrigationMethods;
		this.NContribution = data.NContribution;
		this.units = data.units;
		this.showWells = !!data.needsWells;
		this.wellsForm = data.wellsForm;
	}

	ngOnInit(): void {

		this._subscriptions$ = new Subject();
		super.ngOnInit();
	}

	ngOnDestroy(): void {

		if (!this._subscriptions$) {
			return;
		}

		this._subscriptions$.next(true);
		this._subscriptions$.complete();
	}

	public cancelIncludingNContribution(): void {
		this.nContributionUpdateService.triggerCancelled();
		this.onClose();
	}

	public cancelWells(): void {
		this.cancelIncludingNContribution();
	}

	public continueFromWells(): void {
		let wells: IRanchWellViewModel[];

		wells = this.wellsForm ? this.wellsForm.value as IRanchWellViewModel[] : [];

		if (!wells || wells.length === 0) {
			this.cancelWells();
			return;
		}

		this.nContributionUpdateService.wellsComplete$.pipe(
			take(1),
			takeUntil(this._subscriptions$)
		).subscribe(() => {
			this.showWells = false;
		});

		this.nContributionUpdateService.triggerWellsContinue(wells);
	}

	public updateRecommendationWithNContribution(): void {
		this.nContributionUpdateService.triggerSubmitted();
		this.close();
	}
}
